__turbopack_context__.v({
  "button": "czNPAq_button",
  "centered": "czNPAq_centered",
  "container": "czNPAq_container",
  "item": "czNPAq_item",
  "paper": "czNPAq_paper",
  "three": "czNPAq_three",
  "two": "czNPAq_two",
});
